import { handlePhoneClick } from './trackPhoneCall';

// Botões "Pedir orçamento": levam ao formulário da página (#orcamento).
// Sem formulário na página, mantém-se o comportamento de chamada.
export const handleQuoteClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  const form = document.getElementById('orcamento');
  if (!form) {
    handlePhoneClick(e);
    return;
  }
  e.preventDefault();
  form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  document.getElementById('nome')?.focus({ preventScroll: true });
};
